<template>
  <div v-if="detail" class="cd">
    <div class="cd-title">客户信息</div>
    <div class="cd-detail">
      <div class="avatar">
        <head-image :name="detail.nickName" :url="detail.headImage" :size="48" radius="8px" :online="detail.online"></head-image>
      </div>
      <div class="center-box">
        <div class="cd-name">
          {{ detail.nickName }}
        </div>
        <div class="cd-sourl">来源</div>
      </div>
      <div class="btn-detail" @click="openDetail">查看详情</div>
    </div>
    <div class="remark-box">
      <span class="remark-text" :class="{ 'remark-text--empty': !remarkContent }" :title="remarkContent || '暂无备注'">{{
        remarkContent || "暂无备注"
      }}</span>
      <span class="add-remark-btn" role="button" tabindex="0" @click="onRemarkEdit" @keyup.enter="onRemarkEdit">
        {{ remarkEditLabel }}
      </span>
    </div>
  </div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
export default {
  name: "CustomerVisualProfile",
  components: {
    HeadImage
  },
  props: {
    detail: {
      type: Object,
      default: null
    }
  },
  computed: {
    friend() {
      const id = this.detail && this.detail.id;
      if (id == null) return null;
      return this.friendStore.findFriend(id) || null;
    },
    /** 好友备注优先，其次 detail.remark（与侧栏同步后的字段） */
    remarkContent() {
      const fromFriend = this.friend && this.friend.remarkNickName;
      const fromDetail = this.detail && this.detail.remark;
      const raw = (fromFriend != null && fromFriend !== "" ? fromFriend : fromDetail) || "";
      return String(raw).trim();
    },
    remarkEditable() {
      const id = this.detail && this.detail.id;
      return id != null && this.friendStore.isFriend(id);
    },
    remarkEditLabel() {
      return this.remarkContent ? "修改备注" : "+ 添加备注";
    }
  },
  methods: {
    openDetail() {
      this.$emit("open-detail");
    },
    onRemarkEdit() {
      if (!this.detail || this.detail.id == null) {
        return;
      }
      if (!this.remarkEditable) {
        this.$message.warning("仅好友可修改备注");
        return;
      }
      const f = this.friend;
      const inputValue = f ? f.showNickName || "" : this.detail.nickName || "";
      this.$prompt("请输入好友备注", "修改备注", {
        inputValue,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: (value) => {
          if (value && value.length > 32) {
            return "好友备注长度不能大于32";
          }
        }
      })
        .then((o) => {
          return this.$http({
            url: "/friend/update/remark",
            method: "put",
            data: {
              friendId: this.detail.id,
              remarkNickName: o.value
            }
          });
        })
        .then((friend) => {
          this.friendStore.updateFriend(friend);
          this.chatStore.updateChatFromFriend(friend);
          this.$emit("remark-updated", friend);
          this.$message.success("备注已更新");
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="scss">
.cd {
  // min-height: 396px;
  // padding: 10px 24px 28px;
  box-sizing: border-box;

  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-bottom: 1px solid #f3f4f6;
  .cd-title {
    color: #9ca3af;
    font-family: "Source Han Sans CN";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
    letter-spacing: 1.2px;
    text-transform: uppercase;
    // margin-bottom: 16px;
  }
  .cd-detail {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    // margin-bottom: 16px;
    .center-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      .cd-name {
        color: #191b23;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
      }
      .cd-sourl {
        color: #6b7280;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
      }
    }
    .btn-detail {
      color: #000;
      cursor: pointer;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      max-width: 60px;
      line-height: 18px;
      &:hover {
        color: #2563eb;
      }
    }
  }
  .remark-box {
    display: flex;
    align-items: center;
    gap: 8px;
    .remark-text {
      padding: 4px 8px;
      color: #9333ea;
      font-size: 11px;
      font-style: normal;
      font-weight: 400;
      line-height: 16.5px; /* 150% */
      border-radius: 2px;
      background: #faf5ff;
      flex: 1;
      min-width: 0;
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &--empty {
        color: #9ca3af;
        font-style: italic;
        background: #f3f4f6;
      }
    }

    .add-remark-btn {
      color: #005e9f;
      cursor: pointer;
      font-weight: 500;
      transition: all 0.2s ease;
      border-radius: 2px;
      border: 1px dashed #d1d5db;
      color: #9ca3af;
      text-align: center;
      font-size: 11px;
      font-style: normal;
      padding: 4px 8px;
      font-weight: 400;
      line-height: 16.5px; /* 150% */
      &:hover {
        color: #2563eb;
        border: 1px dashed #2563eb;
      }
    }
  }
}

.cd-avatar-wrap {
  width: 80px;
  height: 80px;
  margin: 0 auto 14px;
  padding: 5px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 0 0 1px #e8edf3 inset;
  box-sizing: border-box;

  .avatar {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;

    :deep(.head-image) {
      border: 3px solid rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transition: all 0.3s ease;

      &:hover {
        border-color: rgba(255, 255, 255, 0.4);
        transform: scale(1.05);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
      }
    }
  }
}

.cd-id-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 6px;
}

.cd-id {
  color: #595c5d;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 180px;
}

.cd-copy-btn {
  flex: 0 0 auto;
  color: #005e9f;
  font-size: 14px;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    color: #0077c8;
    background: rgba(0, 94, 159, 0.08);
  }
}

.cd-info {
  margin-top: 20px;
}

.cd-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-height: 28px;
  margin-bottom: 10px;
}

.cd-row:last-child {
  margin-bottom: 0;
}

.cd-label {
  color: #64748b;
  font-size: 12px;
}

.cd-value {
  color: #2c2f30;
  font-size: 12px;
  text-align: right;
  max-width: 160px;
}

.cd-value--ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cd-value--primary {
  color: #005e9f;
}

.cd-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 66px;
  height: 24px;
  padding: 0 12px;
  border-radius: 999px;
  background: rgba(68, 165, 255, 0.2);
  color: #00528b;
  font-size: 12px;
}

.cd-status-offline {
  background: rgba(244, 67, 54, 0.2);
  color: #c62828;
}

.cd-block-btn {
  margin-top: 24px;
  text-align: center;

  :deep(.el-button) {
    width: 100%;
    height: 36px;
    border-radius: 20px;
    background: linear-gradient(135deg, #ff6b6b, #ff4d4f);
    border: none;
    color: white;
    font-size: 13px;
    font-weight: 500;
    box-shadow: 0 4px 12px rgba(255, 77, 79, 0.3);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(255, 77, 79, 0.4);
      background: linear-gradient(135deg, #ff7875, #ff6b6b);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(255, 77, 79, 0.3);
    }

    :deep(i.el-icon-ban) {
      margin-right: 6px;
    }
  }
}
</style>
